import { tenantSettingsQueries } from '@/features/tenant-settings/api/queries';
import {
  DEFAULT_TENANT_SETTINGS,
  TENANT_SETTINGS_REGISTRY,
  type TenantSettingRecord,
  type TenantSettings
} from '@/features/tenant-settings/consts/registry';
import { useQuery } from '@tanstack/react-query';

const buildSettingsFromRecords = (records: TenantSettingRecord[]): TenantSettings => {
  const settings = { ...DEFAULT_TENANT_SETTINGS };

  for (const record of records) {
    if (record.Code in TENANT_SETTINGS_REGISTRY) {
      const key = record.Code as keyof TenantSettings;
      settings[key] = record.Data;
    }
  }

  return settings;
};

export const useTenantSettings = () => {
  const { data: records = [], isLoading } = useQuery(tenantSettingsQueries.list());
  const settings = buildSettingsFromRecords(records);
  return { settings, isLoading };
};
